import { Disposable } from './disposable.type';

export async function using<T extends Disposable, K>(
  resource: T,
  func: (resource: T) => PromiseLike<K>
) {
  let value: K | undefined;
  let error: unknown | undefined;

  try {
    // If the resource has a wrapper, use it to wrap the callback
    if (resource.wrapper) {
      value = await resource.wrapper(async () => func(resource));
    } else {
      value = await func(resource);
    }

    return value;
  } catch (e) {
    error = e;
    throw e;
  } finally {
    await resource.dispose(value, error);
  }
}

export const usingMultiple = async <T extends Disposable, K>(
  resources: T[],
  func: (resources: T[]) => PromiseLike<K>
): Promise<K> => {
  try {
    return await func(resources);
  } finally {
    await Promise.all(resources.map((resource) => resource.dispose()));
  }
};
